var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { space, layout } from "styled-system";
import { COLOR as themeColor } from "../../theme/constants";
export var IconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  svg {\n    width: 100%;\n    height: auto;\n    ", ";\n    fill: ", ";\n  }\n\n  ", "\n  ", "\n"], ["\n  svg {\n    width: 100%;\n    height: auto;\n    ", ";\n    fill: ", ";\n  }\n\n  ", "\n  ", "\n"])), function (_a) {
  var color = _a.color;
  return color && "color: " + themeColor[color] + ";";
}, function (_a) {
  var color = _a.color;
  return themeColor[color];
}, space, layout);
var templateObject_1;